export default {
  router: [
    {
      exact: true,
      path: '/contract/list',
      title: '合同列表',
    },
  ],
  title: '合同列表',
};
